import React, { useState } from 'react';
import AboutModal from './AboutModal.mjs';
import LegalModal from './LegalModal.mjs';
import ContactModal from './ContactModal.mjs';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    const [modals, setModals] = useState({
        about: false,
        legal: false,
        contact: false,
    });

    const openModal = (modalName) => {
        setModals((prev) => ({ ...prev, [modalName]: true }));
    };

    const closeModal = (modalName) => {
        setModals((prev) => ({ ...prev, [modalName]: false }));
    };

    return (
        <>
            <footer className="app-footer">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-brand">
                            <h3>Nexus of Truth</h3>
                            <p>Discover the truth through articles and insights.</p>
                        </div>

                        <nav className="footer-nav">
                            <div className="footer-nav-section">
                                <h4>Company</h4>
                                <ul>
                                    <li>
                                        <button
                                            onClick={() => openModal('about')}
                                            className="footer-link"
                                        >
                                            About Us
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => openModal('contact')}
                                            className="footer-link"
                                        >
                                            Contact Us
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="footer-nav-section">
                                <h4>Legal</h4>
                                <ul>
                                    <li>
                                        <button
                                            onClick={() => openModal('legal')}
                                            className="footer-link"
                                        >
                                            Terms & Privacy
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="footer-nav-section">
                                <h4>Connect</h4>
                                <div className="social-links">
                                    <a
                                        href="https://twitter.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Twitter"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                                        </svg>
                                    </a>
                                    <a
                                        href="https://linkedin.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="LinkedIn"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                                            <rect x="2" y="9" width="4" height="12"></rect>
                                            <circle cx="4" cy="4" r="2"></circle>
                                        </svg>
                                    </a>
                                    <a
                                        href="https://github.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="GitHub"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div className="footer-bottom">
                        <p>© {currentYear} Nexus of Truth. All rights reserved.</p>
                    </div>
                </div>
            </footer>

            {/* Modals - always rendered but visibility controlled by CSS */}
            <AboutModal isOpen={modals.about} onClose={() => closeModal('about')} />

            <LegalModal isOpen={modals.legal} onClose={() => closeModal('legal')} />

            <ContactModal isOpen={modals.contact} onClose={() => closeModal('contact')} />
        </>
    );
}
